export default __webpack_public_path__ + "static/media/industry.09f4389f.svg";